/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DateRestrictionType {
  None = 'None',
  Historic = 'Historic',
  Future = 'Future'
}
